import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Chevron from '../Chevron'

const DropDown = styled.div`
  position: relative;
  cursor: pointer;
  .select {
    position: absolute;
    background-color: white;
    z-index: 2;
  }
`

const RankingDropdown = ({ allRankings, section, sectionSlug }) => {
  const activeRankingIndex = allRankings.findIndex(
    item => item.link === `/${section}/${sectionSlug}/`,
  )
  const orderedRankingwithActiveOnTop = [
    allRankings[activeRankingIndex],
    ...allRankings.filter((item, index) => index != activeRankingIndex),
  ]

  const [visibleDropDown, setVisibleDropDown] = useState(false)

  return (
    <DropDown>
      <div
        className="activeItem"
        onClick={e => {
          e.preventDefault()
          setVisibleDropDown(!visibleDropDown)
        }}>
        <h2 className="mb-2 text-3xl leading-none text-turquesa sm:text-6xl">
          {orderedRankingwithActiveOnTop[0].name}
          <Chevron className="inline h-4 mb-2 text-turquesa" />
        </h2>
      </div>
      <div className="select">
        {visibleDropDown && (
          <div>
            {orderedRankingwithActiveOnTop.map((ranking, index) => {
              const { name, link } = ranking
              if (index !== 0) {
                return (
                  <Link
                    key={index}
                    to={link}
                    title={name}
                    className="block p-2">
                    <h6 className="text-2xl leading-none sm:text-4xl">
                      {name}
                    </h6>
                  </Link>
                )
              }
            })}
          </div>
        )}
      </div>
    </DropDown>
  )
}

const RankingSelector = ({ allRankings, section, sectionSlug, pretitle }) => {
  return (
    <div className="relative">
      <h1 className="leading-none">
        <small className="block text-3xl leading-none sm:text-6xl">
          {pretitle}
        </small>
        <RankingDropdown
          allRankings={allRankings}
          section={section}
          sectionSlug={sectionSlug}
        />
      </h1>
    </div>
  )
}

export default RankingSelector
